import { Box } from '@chakra-ui/react';

import { mergeMakeModelCounts } from '@/services/filters/algolia/make-model-browse.service';
import { getMakeModelIndex, type MakeModelIndex } from '@/services/filters/algolia/make-model-index.service';
import { parseSearchParamsForSearch } from '@/services/filters/algolia/parse-search-params';

// import { MainSearch } from '../../filters/main-search/main-search';
import MobileFilterModal from '../../filters/new-filters/mobile-filter-modal/mobile-filter-modal';
import { DefaultFilters } from '../../filters/new-filters/new-filters';
import NewFiltersServer from '../../filters/new-filters/new-filters-server';
import { SearchFiltersWrapper } from '../search-filters-wrapper/search-filters-wrapper';
import {
  getFilterCounts,
  searchParamsCache,
} from '../search-results/search-params';

import MakeModelSearchClient from './make-model-search.client';
import styles from './new-search.module.scss';
import ViewAllButton from './view-all-button.client';

export interface NewSearchFiltersProps extends DefaultFilters {
  dealershipId?: string | number;
  searchContext?: any;
  makeModelBase?: Awaited<ReturnType<typeof getMakeModelIndex>>;
}

export function NewSearchFilters({ dealershipId, searchContext, makeModelBase
  , ...defaultFilters }: NewSearchFiltersProps) {
  const rawParams = searchParamsCache.all();
  const params = parseSearchParamsForSearch(rawParams);

  const filterCounts = getFilterCounts(params);
  const serverKey = JSON.stringify(params);

  const totalFilterCount = Object.entries(filterCounts).reduce(
    (acc, [key, value]) => {
      if (key === 'brandsAndRanges') return acc;
      return acc + value;
    },
    0,
  );

  const brandsAndRanges = makeModelBase
    ? mergeMakeModelCounts(
        makeModelBase.filter((brand): brand is MakeModelIndex => brand !== null),
        searchContext.facets.makemodel
      )
    : [];

  return (
    <>
      <SearchFiltersWrapper>
        <Box className={styles.searchWrapper}>
          {makeModelBase && (
            <MakeModelSearchClient
              brandsAndRanges={brandsAndRanges}
              defaultMake={defaultFilters.defaultMake}
              defaultModel={defaultFilters.defaultModel}
            />
          )}
          
          <MobileFilterModal count={totalFilterCount}>
            <NewFiltersServer key={`filters-${serverKey}`} {...defaultFilters} searchContext={searchContext}  makeModelBase={makeModelBase} />
          </MobileFilterModal>
        </Box>
        <Box
          className={styles.filtersDesktop}
          display={{ lg: 'block', base: 'none' }}
        >
          <NewFiltersServer key={`filters-${serverKey}-desktop`} {...defaultFilters} searchContext={searchContext}  makeModelBase={makeModelBase}
            dealershipId={dealershipId}  />
        </Box>
      </SearchFiltersWrapper>
      
      <ViewAllButton isVisible={true} />
    </>
  );
}
